export const NOTIFICATION_LOCAL = 'NOTIFICATION_LOCAL';

export function notificationAddLocalRequest(form) {
    return {
        type: NOTIFICATION_LOCAL,
        payload: {form},
    };
}

export const NOTIFICATION_COMMENT_LOCAL = 'NOTIFICATION_COMMENT_LOCAL';

export function notificationCommentAddLocalRequest(form) {
    return {
        type: NOTIFICATION_COMMENT_LOCAL,
        payload: {form},
    };
}

export const TASK_SOCKET = 'TASK_SOCKET';

export function taskSocket(status) {
    return {
        type: TASK_SOCKET,
        payload: {status},
    };
}

export const SURVEY_SOCKET = 'SURVEY_SOCKET';

export function surveySocket(status) {
    return {
        type: SURVEY_SOCKET,
        payload: {status},
    };
}

export const DAY_OFF_SOCKET = 'DAY_OFF_SOCKET';

export function dayoffSocketSetter(status) {
    return {
        type: DAY_OFF_SOCKET,
        payload: {status},
    };
}

export const NOTIFICATION_SOCKET = 'NOTIFICATION_SOCKET';

export function notificationSocketSetter(status) {
    return {
        type: NOTIFICATION_SOCKET,
        payload: {status},
    };
}

export const NOTIFY_REQUEST = 'NOTIFY_REQUEST';
export const NOTIFY_SUCCESS = 'NOTIFY_SUCCESS';
export const NOTIFY_FAIL = 'NOTIFY_FAIL';

export function notificationRequest() {
    return {
        type: NOTIFY_REQUEST,
        payload: {},
    };
}